<script>
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  extends: Line,
  props: ['height', 'width', 'dataset', 'label', 'title', 'color'],
  mounted () {
 
    // const color = '--' + this.color.split('-')[1]
    const brandPrimary = this.color //getStyle(color)
    const datasets = [
      {
        label: this.title,
        backgroundColor: brandPrimary,
        borderColor: 'rgba(255,255,255,.55)',
        data: this.dataset
      }
    ]

    this.renderChart(
      {
        labels: this.label,
        datasets: datasets
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                min: Math.min.apply(Math, datasets[0].data) - 5,
                max: Math.max.apply(Math, datasets[0].data) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardChart.vue